import React from "react";
import ReactDOM from "react-dom/client";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./styles/tokens.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PrimeReactProvider } from "primereact/api";
import { BrowserRouter } from "react-router-dom";
import { getAuthState, initializeHallticketLib, setNeedsOnboarding, setSignedIn } from "./hallticket-lib";
import { auth } from "./auth/firebase";
import { ThemeProvider } from "./theme";

import ReactGA from "react-ga4";

ReactGA.initialize("G-6B9D7WWT5D");

initializeHallticketLib({
  apiBaseURL: process.env.REACT_APP_API_BASE_URL ?? "https://owl.hallticket.in",
  refreshToken: async () => {
    const refreshedToken = await auth.currentUser?.getIdToken(true);
    if (!refreshedToken) {
      return null;
    }

    const current = getAuthState();
    if (current.status === "signed_in" && current.applicant) {
      setSignedIn(refreshedToken, current.applicant);
    } else if (current.status === "needs_onboarding") {
      setNeedsOnboarding(refreshedToken);
    }

    return refreshedToken;
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <PrimeReactProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PrimeReactProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
